import { Injectable } from "@angular/core";
import { HateoasResourceOperation } from "@lagoshny/ngx-hateoas-client";
import { CommentModel } from "@app/models/rest/comment-model";

@Injectable({
  providedIn: "root"
})
export class CommentRestService extends HateoasResourceOperation<CommentModel> {
  constructor() {
    super(CommentModel);
  }
}
